import { defineStore } from 'pinia';

type ScrollPosition = {
  scrollLeft: number;
  scrollTop: number;
};

export const useScrollPositionStore = defineStore('scrollPosition', {
  state: (): { positions: Record<string, ScrollPosition> } => ({
    positions: {},
  }),
  actions: {
    setPosition(key: string, pos: ScrollPosition) {
      this.positions[key] = pos;
      sessionStorage.setItem(`scroll-position:${key}`, JSON.stringify(pos));
    },
    restorePosition(key: string): ScrollPosition | null {
      const stored = sessionStorage.getItem(`scroll-position:${key}`);
      if (stored) {
        try {
          const pos = JSON.parse(stored);
          this.positions[key] = pos;
          return pos;
        } catch {
          console.warn(`Invalid scroll data for key ${key}`);
        }
      }
      return null;
    },
  },
});
